import { apiService } from './apiService';

export const supportService = {
  async getMyContact() {
    return apiService.get('/support/contact/self');
  },

  async getMyThread() {
    return apiService.get('/support/threads/self');
  },

  async sendMyMessage(message: string) {
    return apiService.post('/support/threads/self/messages', { message });
  },

  async getThreads() {
    return apiService.get('/support/threads');
  },

  async getThread(threadId: string | number) {
    return apiService.get(`/support/threads/${threadId}`);
  },

  async sendThreadMessage(threadId: string | number, payload: { message: string; status?: string }) {
    return apiService.post(`/support/threads/${threadId}/messages`, payload);
  },
};
